import { LyVariantChangedEventListener } from "./base"
import { renderLyPopoverV4 } from "@/utils/renders"

if (!customElements.get('ly-main-product-overview')) {
    customElements.define('ly-main-product-overview', class extends HTMLElement {
        #media = window.matchMedia('(min-width: 768px)')

        connectedCallback() {
            this.poppers = [...this.querySelectorAll('ly-popover-v4')]

            this.#media.addEventListener('change', this.handleMediaChange)
        }

        disconnectedCallback() {
            this.#media.removeEventListener('change', this.handleMediaChange)
        }

        handleMediaChange = () => {
            this.poppers.forEach(popper => popper.close())
        }

    })
}

if (!customElements.get('ly-main-product-overview-item-popover-scroller')) {
    customElements.define('ly-main-product-overview-item-popover-scroller', class extends LyFullScrollCarousel {
        connectedCallback() {
            super.connectedCallback()

            this.fixIndex(this.dataset.variantId)

            this.variantPickerChangeUnsubscriber = window.subscribe('bus:variant_picker_change', this.debouncedHandleVariantChange)
        }

        disconnectedCallback() {
            this.variantPickerChangeUnsubscriber()

            super.disconnectedCallback()
        }

        debouncedHandleVariantChange = debounce(({ variantId }) => this.fixIndex(variantId), 400)

        fixIndex = (variantId) => {
            const index = this._items.findIndex(item => {
                const ids = item.dataset.variantIds.split(',')
                return ids.includes(variantId)
            })
            if (index !== -1) {
                this._index = index
            }
        }
    })
}

if (!customElements.get('ly-main-product-overview-specification')) {
    customElements.define('ly-main-product-overview-specification', class extends LyVariantChangedEventListener {
        connectedCallback() {
            super.connectedCallback()

            this.renderDom = this.querySelector('.js-render')
        }

        disconnectedCallback() {
            super.disconnectedCallback()
        }

        _onVariantChange = ({ variantId }) => {
            const config = this._variantConfigs[variantId]
            const itemsHtml = config.items.map((item, index, thisArr) => {
                let customClass = ''
                if (index >= thisArr.length - 2) {
                    customClass = 'no-border'
                }
                return `
                <div class="ly-main-product-overview-specification-grid-item ${customClass}">
                  <div class="ly-main-product-overview-specification-grid-item-title ly-h4 ly-strong">
                    ${item.title}
                  </div>
                  <div class="ly-main-product-overview-specification-grid-item-value ly-p">
                    ${item.value}
                  </div>
                </div>
                `
            }).join('')

            let documentHtml = ''
            if (config.documents.list.length) {
                documentHtml = `
                <div class="ly-main-product-overview-specification-documents-wrapper">
                  <div class="ly-main-product-overview-specification-documents-title">${config.documents.title}</div>
                  <div class="ly-main-product-overview-specification-documents-inner">
                    <div class="ly-main-product-overview-specification-documents">
                    ${config.documents.list.map(item => `<a class="ly-main-product-overview-specification-document" href="${item.url}" target="_blank">${item.title}</a>`).join('')}
                    </div>
                  </div>
                </div>
                `
            }

            const html = `
            <div class="ly-main-product-overview-specification-popover-wrapper ly-main-product-overview-item-popover-wrapper">
              <div class="ly-main-product-overview-specification-grid-wrapper">
                ${itemsHtml}
              </div>
              ${documentHtml}
            </div>
            `
            this.renderDom.innerHTML = renderLyPopoverV4(this.dataset.popoverId, this.dataset.popoverTitle, html)
        }
    })
}